/**
 * Labstep
 *
 * @module components/OrderRequest/ResourceItemCount
 * @desc Show the number of items added to inventory
 */

import { Flex } from 'labstep-web/core/Flex';
import { Icon } from 'labstep-web/core/Icon';
import { OrderRequestStatus } from 'labstep-web/models/order-request.model';
import type React from 'react';
import type { OrderRequestResourceItemCountProps } from './types';

export const OrderRequestResourceItemCount: React.FC<
  OrderRequestResourceItemCountProps
> = ({ orderRequest }) => {
  if (
    orderRequest.status !== OrderRequestStatus.partially_received &&
    orderRequest.status !== OrderRequestStatus.received
  ) {
    return null;
  }
  return (
    <Flex>
      {orderRequest.resource_item_count >= orderRequest.quantity ? (
        <Icon name="check circle" color="green" />
      ) : (
        <Icon name="warning sign" color="yellow" />
      )}
      <p>{`${orderRequest.resource_item_count} / ${orderRequest.quantity} items added to inventory`}</p>
    </Flex>
  );
};
